import { connect, ConnectedProps } from 'react-redux';
import { useParams } from 'react-router-dom-v5-compat';

import { MessageType } from 'dashboard/lib/interfaces/Message';
import { showMessage } from 'dashboard/redux/actions/messages';
import { RootState } from 'dashboard/redux/store';
import { loadReportSnapshot } from 'dashboard/redux/thunk-actions/report-snapshot';
import DashboardReportsSnapshotView from 'dashboard/views/DashboardReportsSnapshotView';
import useApiLoader from 'lib/hooks/useApiLoader';
import { isPermissionsError, permissionsErrorMessage } from 'lib/permissions-errors';

type Params = { snapshotId: string };
const DashboardReportsSnapshotRoute = (props: PropsFromRedux) => {
  const params = useParams<Params>() as Params;
  const reportSnapshot = props.reportSnapshot;
  const { loading } = useApiLoader({
    loader: () => props.loadReportSnapshot(params.snapshotId),
    deps: [props.loadReportSnapshot, params.snapshotId],
    onError: (error) => {
      if (isPermissionsError(error)) {
        props.showMessage(permissionsErrorMessage(error), MessageType.Failure);
      } else {
        props.showMessage('Failed to load report snapshot.', MessageType.Failure);
      }
    },
    onNetworkError: () =>
      props.showMessage(
        'We are experiencing network issues. Please try again.',
        MessageType.Failure,
      ),
  });

  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  return <DashboardReportsSnapshotView reportSnapshot={reportSnapshot} isLoading={loading} />;
};

const mapStateToProps = (state: RootState) => {
  return {
    featureFlags: state.featureFlags.featureFlags,
    reportSnapshot: state.reportSnapshot.reportSnapshot,
  };
};

const mapDispatchToProps = {
  loadReportSnapshot,
  showMessage,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(DashboardReportsSnapshotRoute);
